<div class="wrapper">
  <div class="popup-row">
    <div class="title">{{ data.title }}</div>
  </div>
  @for (item of data.stacks; track item; let isLast = $last) {
    <div class="popup-row">
      @if (item?.heading) {
        <div
          class="heading"
          >
          {{ item?.heading }}
        </div>
      }
      @if (item?.subheading1) {
        <div
          class="subheading-1"
          >
          {{ item?.subheading1 }}
        </div>
      }
    </div>
    @if (item?.description) {
      <div
        class="popup-row"
        >
        <div class="description-section">
          <div class="label">DESCRIPTION:</div>
          <div class="description">
            {{ item?.description }}
          </div>
        </div>
      </div>
    }
    @if (!isLast) {
      <hr/>
    }
  }
</div>
